import { apolloClient } from "@/plugins/vue-apollo.js";

const signUp = async (_variables) => {
    // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/user/api/mutations/customer/create_customer.graphql"),
      variables: variables,
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { signUp };
